import githubLogo from "./assets/github-logo.svg";
import linkedinLogo from "./assets/linkedin-logo.svg";
import emailLogo from "./assets/email-logo.svg";

import crImg2 from "./assets/CosmicRace-Assets/CosmicRace-2.jpg";
import ragAgentChat from "./assets/RAGAgent-Assets/rag-agent-chat.png";
import ragAgentUpload from "./assets/RAGAgent-Assets/rag-agent-admin-upload.png";
import ragAgentSettings from "./assets/RAGAgent-Assets/rag-agent-admin-settings.png";

// Language-independent data. Translated copy lives in src/i18n/content.js
// and is merged in per-item using the `id` below.

export const CONNECTION_DATA = {
  github: {
    title: "Github",
    logo: githubLogo,
    url: "https://github.com/DvirMagen",
  },
  linkedin: {
    title: "LinkedIn",
    logo: linkedinLogo,
    url: "https://www.linkedin.com/in/dvir-magen-3b900421b/",
  },
  email: {
    title: "DvirMagen@Gmail.com",
    logo: emailLogo,
    url: "mailto:Dvirmagen@Gmail.com",
  },
  cv: {
    url: "/Dvir-Magen-Resume.pdf",
  },
};

export const EDUCATION_DATA = [
  {
    id: "tau-college",
    years: "Oct 2020 – Apr 2024",
  },
];

export const EXPERIENCE_DATA = [
  {
    id: "slash-in",
    period: "Mar 2025 – Apr 2026",
    stack: [
      "React", "Next.js", "TypeScript", "AWS Amplify", "MUI",
      "react-hook-form-mui", "Serverless", "DynamoDB", "GraphQL",
      "REST APIs", "Git & GitHub", "CI/CD", "Cloud Infrastructure", "Figma",
    ],
    url: "https://slash-in.com",
  },
];

export const CORE_PROJECTS = {
  rag: {
    stack: ["Next.js", "TypeScript", "Supabase", "pgvector", "OpenAI", "Tailwind CSS", "Vercel"],
    url: "https://github.com/DvirMagen/rag-agent",
    screenshots: [ragAgentChat, ragAgentUpload, ragAgentSettings],
  },
  cr: {
    stack: ["C#", "Unity", "Java", "Node.js", "Sockets", "Azure"],
    url: "https://github.com/DvirMagen/CosmicRace",
    screenshot: crImg2,
    runners: {
      frameCount: 12,
      fps: 12,
      players: [
        { dir: 'Virtual-Guy-Run-SVG-Frames', name: 'Virtual Guy' },
        { dir: 'Mask-Dude-Run-SVG-Frames',   name: 'Mask Dude' },
        { dir: 'Ninja-Frog-Run-SVG-Frames',  name: 'Ninja Frog' },
        { dir: 'Pink-Man-Run-SVG-Frames',    name: 'Pink Man' },
      ],
    },
  },
  abs: {
    stack: ["Java", "JavaFX", "HTTP", "Multi-threading"],
    url: "https://github.com/DvirMagen/ABS-Project",
  },
  nlp: {
    stack: ["Python", "NLP", "Machine Learning", "Clustering"],
    url: "https://github.com/DvirMagen/NLP_final_project",
  },
  weetbis: {
    stack: ["Java", "Spring Boot", "PostgreSQL", "RESTful APIs"],
    url: "https://github.com/DvirMagen/weetbis",
  },
};

// Four groups per the current resume (adds AI & Core Concepts vs. the old site)
export const SKILLS_DATA = {
  languages: [
    "TypeScript", "JavaScript", "Python", "Java", "C++", "C#", "SQL", "Bash",
  ],
  frontend: [
    "React", "Next.js", "MUI", "HTML", "CSS",
  ],
  backendCloud: [
    "AWS Amplify", "AppSync", "DynamoDB", "Lambda", "Node.js", "FastAPI",
    "PostgreSQL", "MongoDB",
  ],
  aiCore: [
    "LLM Applications", "RAG Pipelines", "Prompt Engineering",
    "Embeddings & Vector Databases", "AI Agents", "REST APIs",
    "Asynchronous Programming", "Data Structures", "Algorithms", "CI/CD",
    "Cloud Fundamentals",
  ],
};
